import { NumberValue, Schema } from '@coveo/bueno';
import { configuration } from '../../../app/common-reducers.js';
import { registerNumberOfResults, updateNumberOfResults, } from '../../../features/pagination/pagination-actions.js';
import { paginationReducer as pagination } from '../../../features/pagination/pagination-slice.js';
import { loadReducerError } from '../../../utils/errors.js';
import { validateInitialState } from '../../../utils/validate-payload.js';
import { buildController, } from '../../controller/headless-controller.js';
const initialStateSchema = new Schema({
    numberOfResults: new NumberValue({ min: 0 }),
});
/**
 * Creates a `ResultsPerPage` controller instance.
 *
 * @param engine - The headless engine.
 * @param props - The configurable `ResultsPerPage` properties.
 * @returns A `ResultsPerPage` controller instance.
 */
export function buildCoreResultsPerPage(engine, props = {}) {
    if (!loadResultsPerPageReducers(engine)) {
        throw loadReducerError;
    }
    const controller = buildController(engine);
    const { dispatch } = engine;
    const getState = () => engine.state;
    const validated = validateInitialState(engine, initialStateSchema, props.initialState, 'buildResultsPerPage');
    const num = validated.numberOfResults;
    if (num !== undefined) {
        dispatch(registerNumberOfResults(num));
    }
    return {
        ...controller,
        get state() {
            return {
                numberOfResults: getState().pagination.numberOfResults,
            };
        },
        set(num) {
            dispatch(updateNumberOfResults(num));
        },
        isSetTo(num) {
            return num === this.state.numberOfResults;
        },
    };
}
function loadResultsPerPageReducers(engine) {
    engine.addReducers({ pagination, configuration });
    return true;
}
